// Advisory Multi-Goal, Multi-Portfolio template (QP-150)
export { advisoryMultiPortfolioStandardNO } from "./advisory-multi-portfolio";
